/*eslint-disable*/
import settings from "../../../configs/settings";
import { Grid, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useContext } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { formatMoney } from "../../utils/utils"

//
// ################################################################################ 
//
const LenteContactoTable = () => {
  const {
    lentesContactoRows,
    obtenerLenteContacto,
    quitarLenteContacto,
    lenteContactoAction,
    lentesContactoSelected,
    seleccionarLentesContacto,
    totalLentesContacto,
    totalLentesContactoContado,
    showCheckBoxesLentesContactoRows,
    showActionsLentesContactoRows,
    showImportesContado,
    gaAction,
  } = useContext(GestionAtencionContext);

  const tableColumns = [
    {
      field: "lenteContactoOjo",
      headerName: "Ojo",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoOjo;
        _val = _val ? _val.toUpperCase().slice(0, 3) : "";
        return _val;
      },
    },
    {
      field: "lenteContactoEsfera",
      headerName: "Esf",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoEsfera.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "lenteContactoCilindro",
      headerName: "Cil",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoCilindro.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "lenteContactoEje",
      headerName: "Eje",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoEje;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "lenteContactoProductoDescripcion",
      headerName: "Producto",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoProductoDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "lenteContactoPresentacionDescripcion",
      headerName: "Presentación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoPresentacionDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "lenteContactoVentaPorUnidad",
      headerName: "VxU",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoVentaPorUnidad;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "lenteContactoPrecioVenta",
      headerName: "Prc Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoPrecioVenta.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "lenteContactoPrecioVentaContado",
      headerName: "Prc Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoPrecioVentaContado.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "lenteContactoCantidad",
      headerName: "Cant",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoCantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "lenteContactoSubtotal",
      headerName: "Sub Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoSubtotal.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "lenteContactoSubtotalContado",
      headerName: "Sub Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.lenteContactoSubtotalContado.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {gaAction.cu === "view" && (
            <>
              <Tooltip title="ver">
                <IconButton
                  size="small"
                  aria-label="update"
                  onClick={() => obtenerLenteContacto(params.row, "view")}
                >
                  <RemoveRedEyeOutlinedIcon />
                </IconButton>
              </Tooltip>
            </>
          )}

          {gaAction.cu !== "view" && showActionsLentesContactoRows && (
            <>
              {lenteContactoAction.cu === "new" ? (
                <>
                  <Tooltip title="actualizar">
                    <IconButton
                      size="small"
                      aria-label="update"
                      onClick={() => obtenerLenteContacto(params.row, "update")}
                    >
                      <EditOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="quitar">
                    <IconButton
                      size="small"
                      aria-label="delete"
                      onClick={() => quitarLenteContacto(params.row)}
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <>
                  <IconButton size="small" disabled={true} aria-label="update">
                    <EditOutlinedIcon />
                  </IconButton>
                  <IconButton size="small" disabled={true} aria-label="delete">
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </>
              )}
            </>
          )}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={3} sx={{ m: 1, p: 2 }}>

        <DataGrid
          rows={lentesContactoRows}
          columns={tableColumns}
          {...tableOptions}
          checkboxSelection={showCheckBoxesLentesContactoRows}
          rowSelectionModel={showCheckBoxesLentesContactoRows ? lentesContactoSelected : []}
          onRowSelectionModelChange={(newSelection) => {
            seleccionarLentesContacto(newSelection);
          }}
        />

        <Grid container spacing={1}>
          <Grid item sm={showImportesContado ? 6 : 12}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "SteelBlue",
                borderRadius: "5px",
                fontSize: "1.1rem",
                fontWeight: "bold",
              }}
            >
              TOTAL DE LISTA: {formatMoney(totalLentesContacto)}
            </Typography>
          </Grid>

          {showImportesContado ? (
            <>
              <Grid item sm={6}>
                <Typography
                  component="div"
                  align="right"
                  sx={{
                    p: 1,
                    mt: 2,
                    backgroundColor: "SteelBlue",
                    borderRadius: "5px",
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                  }}
                >
                  TOTAL DE CONTADO: {formatMoney(totalLentesContactoContado)}
                </Typography>
              </Grid>
            </>
          ) : null}
        </Grid>
      </Paper>
    </>
  );
};
export default LenteContactoTable;
